const COLOR_CODE = {
  GREEN: "#39b536",
  HOVER_GREEN: "#A9DC3B",
  LIGHT_GREEN: "#DEF3D5",
  HEADER_GREEN: "#1e9b24",

  BACKGROUND_GRAY: "#F0F4F8",
  BORDER_GRAY: "#efefef",
  BORDER_DARK_GRAY: "#CDD6DD",
  TABLE_BORDER_DARK_GRAY: "#CACACA",
  BORDER_LIGHT_GRAY: "#cccccc",
  LIGHT_GRAY: "#999999",
  TEXT_GRAY: "#666666",
  FOCUS_GRAY: "#666666",
  FOOTER_MENU_BUTTON_GRAY: "#C2D0D7",
  CHARCOAL_GRAY: "#32383e",
  PALE_GRAY: "#CDD7E1",

  LIGHT_BLACK: "#333333",
  LIGHT_BLACK2: "#4d4d4d",

  WHITE: "#ffffff",
  RED: "#c50d12",
  ORANGE: "#f7931e",
  BLUE: "#3399FF",
  DEEP_BLUE: "#0071BC",

  SIMULATION_CELL_GRAY: "#F2F2F2",
  SIMULATION_COURSE_GRAY: "#E6E6E6",
  SIMULATION_BORDER_GRAY: "#C8C8C8",
  SIMULATION_CIRCLE_BLUE: "#0071BC",
  SIMULATION_CIRCLE_BROWN: "#8C6239",
  SIMULATION_TEXT_ORANGE: "#F15A24",
  SIMULATION_RED: "#FC1F1F",
} as const

export default COLOR_CODE
